import { Directive, inject, Input } from '@angular/core';
import { IAttribut, IAttributDefinition } from '@mng/mgs-lib';
import { FormControl } from '@angular/forms';
import { FloatLabelType, MatFormFieldAppearance } from '@angular/material/form-field';
import { IUiAttribut } from '../../attribut-ui.types';
import { getValidationMessage } from '@mng/mng-inputs';
import { DienstleistungService } from '../../../../dienstleistung/dienstleistung.service';

@Directive()
export class MgsFieldDefaultComponent {
  _uiAttribut: IUiAttribut;

  appearance: MatFormFieldAppearance = 'outline';

  floatLabel: FloatLabelType = 'auto';

  readonly service = inject(DienstleistungService);

  dienstleistung = this.service.dienstleistung;

  style: {};

  @Input()
  set uiAttribut(value: IUiAttribut) {
    // console.log('!!!!set attribute', value);
    this._uiAttribut = value;
    value.component = this;

    this.attributSet();
  }

  get uiAttribut(): IUiAttribut {
    return this._uiAttribut;
  }

  get formControl(): FormControl {
    return this.uiAttribut.formControl;
  }

  attributSet() {
    return;
  }

  get attribut(): IAttribut {
    return this._uiAttribut?.attribut;
  }

  get definition(): IAttributDefinition {
    return this.attribut?.definition;
  }

  get label(): string {
    return this.definition.label;
  }

  get defId(): number {
    return this.definition.id;
  }

  get validationMessage(): string {
    return getValidationMessage(this.formControl);
  }

  onKeydown(event: KeyboardEvent) {
    //   TODO: ???
  }
}
